import { DatePipe } from '@angular/common';
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { AppComponent } from 'src/app/app.component';

@Component({
  selector: 'app-loans-create-contract',
  templateUrl: './loans-create-contract.component.html',
  styleUrls: ['./loans-create-contract.component.scss']
})
export class LoansCreateContractComponent implements OnInit {

  @HostListener('window:popstate', ['$event'])
  onPopState(event:any) {
    let dataStore = JSON.stringify(this.contract.getRawValue());
    this.authService.loanDataStore2(dataStore);
  }

  public contract: FormGroup;
  showMsg = false;
  msg: any;
  userRole: string | null;
  quoteData: any;
  editData: any;
  invalids: string[];

  saveData: any;

  isLoan = false;

  constructor(private datePipe: DatePipe, private appComp: AppComponent, private _fb: FormBuilder, private route: ActivatedRoute, private router: Router, private authService: AuthenticationService) {

    this.route.queryParams.subscribe(() => {
      if (this.router.getCurrentNavigation()!.extras.state) {
        let data:any = this.router.getCurrentNavigation()!.extras.state;
        console.log(data);
        this.quoteData = data.quoteData;
        this.editData = data.editData;
        console.log(this.editData);

        if(this.quoteData){
          this.isLoan = this.quoteData.loanType == 'Prestamo Personal' ? true : false;
        }

        if(this.editData){
          this.isLoan = this.editData.loanType == 'Prestamo Personal' ? true : false;
        }

      }else{
        this.router.navigateByUrl('loans/quotation');
      }
    });

   }

  addChildForm(name: string, group: FormGroup) {
    console.log(name);
    this.contract.addControl(name, group);
  }

  

  showValidators(){
    this.contract.get("garantizador")?.clearValidators();
    // this.contract.get("garantizador")?.updateValueAndValidity();
    const invalid = [];
    const controls = this.contract.controls;
    
    for (const name in controls) {
        if (controls[name].invalid) {
            invalid.push(name);
            var element = document.querySelector("input[formControlName='"+name+"']");
            element?.classList.add('reqField');
        }
    }
    console.log(invalid);
    this.invalids = invalid;

  }

  emptyDataStore(){
    this.authService.emptyLoanDataStore2();
    location.reload();
  }

  ngOnInit(): void {
    this.userRole = this.authService.getUserRole();

    this.contract = this._fb.group({
      // loanType: ["Prestamo Personal"],
      garantia: ["",[Validators.required]],
      proposito: ["",[Validators.required]],
      comoSeEntero: ["",[Validators.required]],
    });

    if(!this.isLoan){
      this.contract.addControl('bienesJson', this._fb.control(''));
    }

    //this.contract.controls['qPremium'].disable();
    let dataStore = this.authService.getLoanDataStore2();
    if(this.editData){
      console.log(this.editData);
      this.contract.patchValue(this.editData);
      this.contract.patchValue({
        garantia: this.editData.garantia ? 'true' : 'false'
      });
      this.saveData = this.editData;

    }
    else if(dataStore){      
      console.log(JSON.parse(dataStore));
      this.contract.patchValue(JSON.parse(dataStore));
      this.saveData = JSON.parse(dataStore);
      this.saveData.compServicioId = this.saveData["select-company"].idCompany;
      this.saveData.idProducer = this.saveData["select-producer"].idProducer;
    }

    
    // this.contract.get("coSolicitante")?.clearValidators();
    // this.contract.get("garantizador")?.clearValidators();

    
  }

  // setAutoSave(){
  //   this.autoSave = setInterval(() => {
  //     let dataStore = JSON.stringify(this.contract.getRawValue());
  //     this.authService.loanDataStore2(dataStore);
  //   }, 2000);
  // }

  createContract(){
    console.log(this.contract.getRawValue());
    this.appComp.loading = true;
    this.showMsg = false;
    // if (this.contract.invalid) {
    //   this.showMsg = true;
    //   this.appComp.loading = false;
    //   this.msg = "Faltan campos por llenar..."
    //   return;
    // }

    let invalid = [];
    const controls = this.contract.controls;
    
    for (const name in controls) {
        if (controls[name].invalid) {
            invalid.push(name);
            var element = document.querySelector("input[formControlName='"+name+"']");
            element?.classList.add('reqField');
        }
    }

    let index = invalid.indexOf('garantizador');
    invalid.splice(index, 1);
    index = invalid.indexOf('coSolicitante');
    invalid.splice(index, 1);

    // if(invalid.length > 2 || !(invalid.length == 2 && invalid.some(x=>x == 'garantizador') && invalid.some(x=>x == 'coSolicitante'))){
    if(invalid.length > 0){
      this.showMsg = true;
      this.appComp.loading = false;
      this.msg = "Faltan los siguientes campos por llenar: " + invalid;
      return;
    }

    



    let contract = {
      ...this.contract.getRawValue(),
      ...this.quoteData
    }

    //data modification
    contract.compServicioId = contract['select-company'].idCompany;
    contract.compServicioName = contract['select-company'].insCompany;
    contract.idProducer = contract['select-producer'].idProducer;
    
    delete contract['select-company'];
    delete contract['select-producer'];

    console.log(contract);

    //stringify
    let keys = Object.keys(contract);
    keys.forEach((key, index) => {
      if(typeof contract[key] == 'object'){
        contract[key] = JSON.stringify(contract[key]);
      }
    });
    console.log(contract);

    if(this.editData){
      contract.createdDate = this.editData.createdDate;
      contract.modifiedDate = this.editData.modifiedDate;
      contract.otherNotes = this.editData.loanApprovalNotes;
      contract.txtMsgs = this.editData.txtMsgs;
      contract.isApproved = this.editData.isApproved;
      contract.notes = this.editData.notes;
      contract.id = this.editData.id;
      this.authService.updateLoanContract(contract).then((res:any)=>{
        console.log(res);
        this.appComp.loading = false;
        this.authService.emptyLoanDataStore();
        this.authService.emptyLoanDataStore2();
        this.router.navigateByUrl('/loans/contract-details/'+contract.id);
      }, (err:any)=>{
        this.appComp.loading = false;
        console.log(err);
      })
    }else{
      this.authService.createLoanContract(contract).then((res:any)=>{
        console.log(res);
        this.appComp.loading = false;
        this.authService.emptyLoanDataStore();
        this.authService.emptyLoanDataStore2();
        this.router.navigateByUrl('/loans/contract-details/'+res.id);
      }, (err:any)=>{
        this.appComp.loading = false;
        console.log(err);
      })
    }
    
    
  }




}
